import { createContext, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedGame, clearUpdatedGameId, deleteGame, fetchFeaturedGames, fetchGameBySlug, fetchGameFilters, fetchGames, fetchMyFavoriteGames, fetchRecentlyPlayedGames, fetchUserGames, generateGameSaveToken, updateGame, updateGameBuild, uploadGameBuild } from "../store/home-page";


const GameContext = createContext(undefined);

export const GameProvider = ({ children }) => {
	const { 
		games,
		selectedGame,
		loadingMore,
		recommendedGames,
		updatedGameId,
		favoriteGames,
		recentlyPlayedGames,
		pagination = {},
		filtersOptions = {},
		filtersLoaded, 
		isLoading,
		error,
		uploadProgress,
		featuredGames,
		userGames,
		userGamesPagination,
		favoriteGamesPagination,
		recentGamesPagination,
	} = useSelector((state) => state.games);
	const dispatch = useDispatch();
	const value = useMemo(() => ({
		games,
		selectedGame,
		recommendedGames,
		updatedGameId,
		favoriteGames,
		recentlyPlayedGames,
		isLoading,
		error,
		loadingMore,
		uploadProgress,
		pagination,
		filtersOptions,
		filtersLoaded,
		featuredGames,
		userGames,
		userGamesPagination,
		favoriteGamesPagination,
		recentGamesPagination,
		
		fetchFeaturedGames: () => dispatch(fetchFeaturedGames()),
		GenerateGameSaveToken:(id)=> dispatch(generateGameSaveToken(id)),
		GetGameById:(id)=> dispatch(fetchGameBySlug(id)),
		UploadGameBuild:async (payload)=>{return await dispatch(uploadGameBuild(payload))},
		UpdateGame:async (id, payload) => {return await dispatch(updateGame({ id, payload }))},
		UpdateGameBuild:async (id, payload) => {return await dispatch(updateGameBuild({ id, formData:payload }))},
		deleteGame:async (id) => {return await dispatch(deleteGame(id))},
		clearUpdatedGameId: () => dispatch(clearUpdatedGameId()),
		clearSelectedGame:()=> dispatch(clearSelectedGame()),
		fetchRecentGames: ({ page = 1, limit = 9 } = {}) => dispatch(fetchRecentlyPlayedGames({ page, limit })),
		fetchFaivoriteGames: ({ page = 1, limit = 9 } = {}) => dispatch(fetchMyFavoriteGames({ page, limit })),
		fetchAllGames: ({ page = 1, limit = 20, ...rest } = {}) => dispatch(fetchGames({ page, limit, ...rest })),
		fetchFilters: () =>  dispatch(fetchGameFilters()),
		fetchUserGames:({ page = 1, limit = 9 } = {})=> dispatch(fetchUserGames({ page, limit })),
	}), [
		games,
		selectedGame,
		updatedGameId,
		favoriteGames,
		recentlyPlayedGames,
		isLoading,
		error,
		userGames,
		uploadProgress,
		loadingMore,
		pagination,
		filtersOptions,
		filtersLoaded,
		featuredGames,
		userGamesPagination,
		favoriteGamesPagination,
		recentGamesPagination,
	])
	return (
		<GameContext.Provider value={value}>
			{children}
		</GameContext.Provider>
	);
};

export const useGame = () => {
	const context = useContext(GameContext);
	if (context === undefined) {
		throw new Error("useGame must be used within a GameProvider");
	}
	return context;
}